module.exports = __webpack_public_path__ + "img/profile_five_004.10154c59.png";